import React from 'react'

import { Route, Switch } from 'react-router-dom'
import { sidebarRoutes, IRoute } from '../navigation/routes'
import { TRootState } from 'redux/reducers/rootReducer';
import { useSelector } from 'react-redux';
import Topbar from 'components/navigation/topbar/Topbar';
import { NotFound404Page } from './404/NotFound404Page';


function Content()
{
  // FocusStyleManager.onlyShowFocusOnTabs();
  const navState = useSelector((state: TRootState) => state.app.navigation);

  let rootClass = 'content-viewport';
  if (navState.sidebarOpen) rootClass += ' content-viewport--smaller';

  return (
    <div className={rootClass}>
      <Topbar />
      <div className="content-container">
        <Switch>
          {
            sidebarRoutes.map((route: IRoute, index: number) =>
              <Route
                key={route.routeId}
                path={route.path}
                exact={route.exact}
                component={route.component}
              />
            )
          }
          <Route component={NotFound404Page} />
        </Switch>
      </div>
    </div>
  )
}

export default Content
